const OffSelectAttribute = (values, { name }) => {
  const {
    attributeId, isCustomDescription, description, value, ...rest
  } = values

  const isCustomName = rest.isCustomName === 'true'

  const config = {
    ...rest,
    isCustomName,
    ...!isCustomName && { name },
    description: isCustomDescription ? description : '',
    value: value && value.length > 0 ? value : null
  }
  return config
}

export default OffSelectAttribute
